import { apiService } from './apiService';

export const ingestionService = {
  loadDataSources: (tenantId: string) =>
    apiService.get(`/api/datasource/getAllSources`, {}, 'backend'),


  getKBWentities: (workspaceid: string) =>
    apiService.get(`/api/datasource/getKBWentities?id=${workspaceid}`, {}, 'backend'),

  loadkbEntitiesList: () =>
    apiService.get(`api/KnowledgeBase/kbEntitiesList`, {}, 'backend'),

  /** Scheduler > Add Schedule > Destination > Knowledge Base. Tenant from JWT. */
  getKnowledgeBasesForTenant: () =>
    apiService.get('/api/KnowledgeBase/GetKnowledgeBasesForTenant', {}, 'backend'),
  getKWEntityById: (KWid: string) =>
    apiService.get(`/api/KnowledgeBase/KWEntityById?KWId=${KWid}`, {}, 'backend'),
  /** Scheduler controller: all scheduler API under /api/Scheduler */
  scheduler: {
    /** Entities for Add Schedule > Select Entity (Database Tables & Queries). Tenant from JWT. */
    getEntities: () => apiService.get('/api/Scheduler/Entities', {}, 'backend'),
    /** Knowledge bases for Add Schedule > Destination > Knowledge Base. Tenant from JWT. */
    getKnowledgeBasesForDestination: () =>
      apiService.get('/api/Scheduler/KnowledgeBasesForDestination', {}, 'backend'),
    list: () => apiService.get('/api/Scheduler', {}, 'backend'),
    create: (dto: unknown) => apiService.post('/api/Scheduler', dto, 'backend'),
    update: (id: string, dto: unknown) => apiService.put(`/api/Scheduler/${id}`, dto, 'backend'),
    delete: (id: string) => apiService.delete(`/api/Scheduler/${id}`, 'backend'),
    setEnabled: (id: string, enabled: boolean) =>
      apiService.patch(`/api/Scheduler/${id}/enabled`, { enabled }, 'backend'),
    triggerScheduleLoad: (id: string) =>
      apiService.post(`/api/Scheduler/${id}/TriggerScheduleLoad`, {}, 'backend'),
    /** GET /api/Scheduler/SchedulerLogs?schedulerId=... */
    getSchedulerLogs: (schedulerId: string) =>
      apiService.get(`/api/SchedulerLogs?schedulerId=${encodeURIComponent(schedulerId)}`, {}, 'backend'),
    /** DELETE /api/Scheduler/{id} — clear logs for this schedule */
    clearLogs: (id: string) => apiService.post(`/api/SchedulerLogs/ClearLogs?scheduleId=${id}`,{}, 'backend'),
  },

  deleteKBEntityGroup: (id: any, userid: any) =>
    apiService.post(`/api/KnowledgeBase/delete/${id}?uid=${userid}`, {}, 'backend'),

  testConnection: (data: any) =>
    apiService.post('/api/datasource/test-connection', data, 'backend'),

  renameIngestion: (data: { tenantID: string; id: string; newTitle: string }) =>
    apiService.post('/api/datasource/rename', data, 'backend'),

  postIngestionEntity: (data: any) =>
    apiService.post('/api/datasource', data, 'backend'),

  deleteDataSource: (id: string) =>
    apiService.post('/api/datasource/Delete/' + id, null, 'backend'),


  loadConnectionSchema: (data: any) =>
    apiService.post('/api/datasource/schema-preview', data, 'backend'),

  uploadFile: (formData: FormData) =>
    apiService.postFormData('/api/Upload/file', formData, 'backend'),

  chatQuery: (payload: {
    sessionid: string;
    query: string;
    datasources: {
      datasourceid: string;
      typeofcontext: string;
      contexts: {
        contextid: string;
        contextcollectionname: string;
      }[];
    }[];
  }) =>
    apiService.post('/queryAgent/', payload, 'selfic_core'),

  getAvailableContexts: () =>
    apiService.get('/queryAgent/data-sources/with-contexts', {}, 'selfic_core'),
  getVectorStores: () =>
    apiService.get('/api/VectorStoreConfiguration/list', {}, 'backend'),

  createVectorStore: (dto: {
    provider: string;
    apiKey?: string;
    endpointUrl?: string;
    collectionName?: string;
    isDefault?: boolean;
    isActive?: boolean;
    description?: string;
    region?: string;
    intendedUsage?: string;
    tenantOrClient?: string;
  }) =>
    apiService.post('/api/VectorStoreConfiguration', dto, 'backend'),

  updateVectorStore: (id: string, dto: {
    provider: string;
    apiKey?: string;
    endpointUrl?: string;
    collectionName?: string;
    isDefault?: boolean;
    isActive?: boolean;
    description?: string;
    region?: string;
    intendedUsage?: string;
    tenantOrClient?: string;
  }) =>
    apiService.put(`/api/VectorStoreConfiguration/${id}`, dto, 'backend'),

  deleteVectorStore: (id: string) =>
    apiService.delete(`/api/VectorStoreConfiguration/${id}`, 'backend'),

  getLLMConfigurations: (tenantId: string) =>
    apiService.get(`/api/LLMConfiguration/${tenantId}`, {}, 'backend'),
  generateQuery: (payload: any) =>
    apiService.post('/queryAgent/generate', payload, 'selfic_core'),
  runCreditEvaluation: () =>
  apiService.get('/api/CreditEvaluation/run-evaluation', {}, 'backend'),


};

